import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { OutputCaseComponent } from 'app/crm/output-case/output-case.component'
import { isNullOrUndefined } from 'util'
import { Subscription } from 'rxjs/Subscription'
import { StoreService } from '../../service/store.service'
import { OutputCaseTableComponent } from 'app/crm/output-case-table/output-case-table.component'
import { getAllDebugNodes } from '../../../../node_modules/@angular/core/src/debug/debug_node'
import { AuthorizeService } from 'app/service/authorize.service'
@Component({
  selector: 'app-output',
  templateUrl: './output.component.html',
  styleUrls: ['./output.component.scss']
})
export class OutputComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('outputCaseTable')
  outputCaseTableComponent: OutputCaseTableComponent
  @ViewChild('outputCaseComponent') outputCaseComponent: OutputCaseComponent
  subscription: Subscription
  subscriptionId: Subscription
  caseId
  getPrint
  securitySymbol
  print = false
  pdf = false
  printPage = false
  symbol
  displayComponent = false
  isAe
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private authorization: AuthorizeService
  ) { }

  reInitialTable() {
    if (this.outputCaseTableComponent) {
      this.outputCaseTableComponent.onChangeData()
    }
  }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print
    isNullOrUndefined(pdf) ? (this.pdf = false) : (this.pdf = pdf)
    isNullOrUndefined(print) ? (this.print = false) : (this.print = print)
    if (!isNullOrUndefined(symbol)) {
      this.symbol = symbol
    }
    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(
        response => {
          if (!response) {
            return
          }
          this.symbol = response['securitySymbol']
          this.displayComponent = true
          if (this.symbol === null) {
            this.displayComponent = false
          }
        },
        error => {
          this.displayComponent = false
        }
      )

    this.print || this.pdf ? (this.printPage = true) : (this.printPage = false)

    this.subscriptionId = this.store
      .getOutputCaseByIdObservable()
      .subscribe(newId => {
        this.caseId = newId
      })
  }

  sendcaseId(id) {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
      })
    this.caseId = id
    this.outputCaseComponent.getCrmCaseById(id)
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmail(this.symbol, this.caseId, this.cpmService)
    )
    arrayOfFunctions.set('print', this.exportPrint(this.symbol, this.caseId))
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol, this.caseId))
    return arrayOfFunctions
  }

  exportPrint = function (symbol, caseId) {
    return function executiveSummaryPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      window.open(
        `/#/crmoutput/${endcodeSymbol}/${caseId}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol, caseId) {
    const service = this.cpmService
    return function executiveSummaryPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/crmoutput?symbol=${endcodeSymbol}&caseId=${caseId}`
      )
    }
  }

  exportEmail = function (symbol, caseId, service) {
    return function mailsectorPopup() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveCrmOutputPdfFile(endcodeSymbol, caseId).then(filename => {
        const subject = 'Crm Output'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }

  ngOnDestroy(): void {
    if (!isNullOrUndefined(this.subscription)) {
      this.subscription.unsubscribe()
    }
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('CRM_CASE_VIEW')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/output/output.component.ts